import $ from 'jquery';

$(window).scroll(function() {    
  var scroll = $(window).scrollTop();

  if (scroll > 0) {
      $(".website-header").addClass("sticky-header");
  } else {
    $(".website-header").removeClass("sticky-header");
  }
});